const lang = {
  page_title: '林分収穫表',
  breadcrumb: {
    list: '林分収穫表',
    detail: '林分収穫表詳細',
  },
  button: {
    add: '＋林分収穫表を追加する',
    read_start: '読込開始',
  },
  select_prefecture: {
    prefecture: '都道府県',
    default_text: '全国',
  },
  table: {
    name: 'エリア名',
    prefecture: '都道府県',
    updated_at: '最終更新日',
    tree_species: '登録樹種',
    delete: '削除',
  },
  detail: {
    latest_updated_at: '最終更新日',
    head: {
      tree_species: '樹種',
      graph: 'グラフ',
      yield_tables_data: '林分収穫表データ',
    },
    table: {
      position1: '地位Ⅰ',
      position2: '地位Ⅱ',
      position3: '地位Ⅲ',
      position4: '地位Ⅳ',
      position5: '地位Ⅴ',
      position6: '地位Ⅵ',
      position7: '地位Ⅶ',
      position8: '地位Ⅷ',
      position9: '地位Ⅸ',
      position10: '地位Ⅹ',
    },
    graph: {
      x_title: '林齢',
      y_title: 'ha当たりの幹材積（m3/ha）',
    },
    content: {
      contract_start: '契約開始：',
      contract_end: '契約終了：',
      delete_organization: '契約団体を削除する',
      no_data: '登録情報がありません。',
    },
  },
  create_modal: {
    title: '林分収穫表の追加',
    name: 'エリア名',
    prefecture: '都道府県',
    csv_file: 'csvファイル',
    original_file: '原本ファイル',
    forest_age_interval: '林齢の間隔',
    placeholder: {
      name: 'エリア名を入力',
    },
  },
  edit_modal: {
    title: '契約団体の編集',
    name: '団体名',
    placeholder: {
      name: '団体名を入力',
      memo: '説明を入力...',
    },
  },
  create_member_modal: {
    title: 'アカウントの追加',
    name: 'アカウント名',
    email: 'メールアドレス',
    placeholder: {
      name: 'アカウント名を入力',
      email: 'メールアドレスを入力',
    },
  },
  delete_member_modal: {
    title: 'アカウントの削除',
    explain:
      'アカウントを削除すると、アカウント利用者は再びFCSにログインできなくなります。アカウント利用者の承認を得てから、削除を行なってください。',
  },
  delete_modal: {
    title: '林分収穫表の削除',
    explain:
      '契約団体の利用者が使用している林分収穫表を削除すると、契約団体のもとでエラーが生じます。必ず契約団体の利用者が使用していないことを確認してから削除してください。',
  },
  common_model: {
    errors: {
      required_name: '団体名は必須です。',
      limit_name: '団体名は50文字以内で入力してください。',
      limit_memo: '説明は500文字以内で入力してください。',
      required_endedAt: '契約終了は必須です。',
    },
  },
  preview_yield_table_modal: {
    title: '登録内容の確認',
  },
}

export default lang
